import { Course, Education, Experience, Hobby, Internship, LinkPdf, Work } from "./store"

export const base64Placeholder = 'data:image/png;base64,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'

export const testDataLanguages = [
    { id: '1', name: 'English', level: 5 },
    { id: '2', name: 'Dutch', level: 5 },
    { id: '3', name: 'German', level: 3 },
    { id: '4', name: 'French', level: 4 },
    { id: '5', name: 'Spanish', level: 2 },
    { id: '6', name: 'Italian', level: 2 },
    { id: '7', name: 'Mandarin', level: 1 },
    { id: '8', name: 'Japanese', level: 1 },
    { id: '9', name: 'Arabic', level: 2 },
    { id: '10', name: 'Russian', level: 2 },
    { id: '11', name: 'Portuguese', level: 3 },
    { id: '12', name: 'Swedish', level: 2 },
    { id: '13', name: 'Norwegian', level: 2 },
    { id: '14', name: 'Turkish', level: 2 },
    { id: '15', name: 'Polish', level: 2 },
  ];

  
export const testDataSidePanel = [
  { id: '1', name: 'JavaScript', level: 5 },
  { id: '2', name: 'React', level: 4 },
  { id: '3', name: 'CSS', level: 3 },
  { id: '4', name: 'Python', level: 4 },
  { id: '5', name: 'TypeScript', level: 4 },
  { id: '6', name: 'HTML', level: 5 },
  { id: '7', name: 'Node.js', level: 4 },
  { id: '8', name: 'Java', level: 3 },
  { id: '9', name: 'SQL', level: 4 },
  { id: '10', name: 'C++', level: 2 },
  { id: '11', name: 'Ruby', level: 3 },
  { id: '12', name: 'PHP', level: 3 },
  { id: '13', name: 'Swift', level: 4 },
  { id: '14', name: 'Go', level: 4 },
  { id: '15', name: 'Kotlin', level: 4 },
  { id: '16', name: 'Vue.js', level: 3 },
  { id: '17', name: 'Angular', level: 3 },
  { id: '18', name: 'Django', level: 4 },
  { id: '19', name: 'Ruby on Rails', level: 3 },
  { id: '20', name: 'MongoDB', level: 4 },
  { id: '21', name: 'Docker', level: 4 },
  { id: '22', name: 'AWS', level: 4 },
  { id: '23', name: 'Jest', level: 3 },
  { id: '24', name: 'TensorFlow', level: 3 },
  { id: '25', name: 'Sass', level: 3 },
  { id: '26', name: 'Firebase', level: 4 },
  { id: '27', name: 'GraphQL', level: 4 },
  { id: '28', name: 'Redux', level: 4 },
  { id: '29', name: 'Elasticsearch', level: 3 },
  { id: '30', name: 'Vuex', level: 3 },
];

export const testData: Experience[] = [{
    type: 'education',
    education: 'edu1',
    id: 'edu1',
    institution:'edu1',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'edu1',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: false
}, {
    type: 'education',
    education: 'edu2',
    id: 'edu2',
    institution:'edu2',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'edu2',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: false
}, {
    type: 'internship',
    role: 'intenr1',
    id: 'intenr1',
    institution:'intern1',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'intern1',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: false,
    company: 'interen'
}, {
    type: 'internship',
    role: 'intreern2',
    id: 'intreern2',
    institution:'intreern2',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'intreern2',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: false,
    company: 'interen'
}, {
    type: 'work',
    role: 'work1',
    id: 'work1',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'work1',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: false,
    company: 'work1'
}, {
    type: 'work',
    role: 'work2',
    id: 'work2',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'work2',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: true,
    company: 'work2'
}, {
    type: 'work',
    role: 'work3',
    id: 'work3',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'work3',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: true,
    company: 'work3'
}, {
    type: 'work',
    role: 'work8',
    id: 'work8',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'work8',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: true,
    company: 'work8'
}, {
    type: 'work',
    role: 'work9',
    id: 'work9',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'work9',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: true,
    company: 'work9'
},  {
    type: 'work',
    role: 'work90',
    id: 'work90',
    endDate: '2023-01-02',
    startDate: '2024-01-23',
    city: 'work90',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining",
    present: true,
    company: 'work90'
}]

export const testCourses: Course[] = [
    { id: '1', name: 'Web Development Bootcamp', status: 'completed' },
    { id: '2', name: 'Advanced React', status: 'completed' },
    { id: '3', name: 'Python for Data Science', status: 'completed' },
    { id: '4', name: 'Docker & Kubernetes', status: 'in progress' },
    { id: '5', name: 'Machine Learning Basics', status: 'completed' },
    { id: '6', name: 'TypeScript Essentials', status: 'completed' },
    { id: '7', name: 'Agile Project Management', status: 'planned' },
  ];

  
  export const testLinks: LinkPdf[] = [
    { id: '1', name: 'GitHub', url: 'https://github.com/yourusername', status: 'active' },
    { id: '2', name: 'LinkedIn', url: 'https://linkedin.com/in/yourprofile', status: 'active' },
    { id: '3', name: 'Portfolio', url: 'https://yourportfolio.com', status: 'active' },
    { id: '4', name: 'Dev.to Blog', url: 'https://dev.to/yourhandle', status: 'inactive' },
    { id: '5', name: 'Twitter', url: 'https://twitter.com/yourhandle', status: 'active' },
    { id: '6', name: 'Medium', url: 'https://medium.com/@yourhandle', status: 'active' },
    { id: '7', name: 'Stack Overflow', url: 'https://stackoverflow.com/users/123456', status: 'active' },
  ];

  export const testHobbies: Hobby[] = [
    { id: '1', name: 'Photography', status: 'active' },
    { id: '2', name: 'Cycling', status: 'active' },
    { id: '3', name: 'Gaming', status: 'casual' },
    { id: '4', name: 'Cooking', status: 'active' },
    { id: '5', name: 'Traveling', status: 'frequent' },
    { id: '6', name: 'Reading', status: 'daily' },
    { id: '7', name: 'Music Production', status: 'hobbyist' },
  ];

  
export const testInternship: Internship[] = []

export const testWork: Work[] = [] 

export const CHARS_PER_PAGE = 1900

export const SIDEPANEL_MAX_ITEMS_FIRST_PAGE = 12

export const SIDEPANEL_MAX_ITEMS_PAGE = 35
